import * as React from "react";
const InvoicesView = React.lazy(() => import("./InvoicesViewContainer"));

export { InvoicesView };
